/* global FWP */

const PropelWoocommerce = () => {
	function init() {
		variationSizeButtons();
		productArchiveFilterAccordion();
		refreshResetButton();
		toggleResetButton();
	}

	function checkSearchParams() {
		const searchParams = new URLSearchParams(window.location.search);
		return searchParams.toString() !== '';
	}

	function refreshResetButton() {
		const refreshButton = document.querySelector('.js-reset-filters');

		if (refreshButton) {
			refreshButton.addEventListener('click', function () {
				window.location.replace(location.pathname);
			});
		}
	}

	function toggleResetButton() {
		const resetButton = document.querySelector('.js-reset-filters');
		//console.log(checkSearchParams()); // Log the return value of checkSearchParams()

		if (resetButton) {
			//console.log('Reset button found'); // Log when reset button is found
			if (checkSearchParams()) {
				resetButton.classList.remove('hidden');
			} else {
				resetButton.classList.add('hidden');
			}
		}
	}

	/**
	 * Custom variation size buttons.
	 */
	function variationSizeButtons() {
		const sizeButtonsWrapper = document.querySelector('.variation-buttons');
		//console.log('sizeButtonsWrapper:', sizeButtonsWrapper);
		if (!sizeButtonsWrapper) return;

		const sizeButtons = sizeButtonsWrapper.querySelectorAll('button');
		const sizeSelect = document.querySelector(
			'select[name="attribute_size"]'
		);

		if (sizeButtons) {
			sizeButtons.forEach((button) => {
				button.addEventListener('click', (e) => {
					e.preventDefault();
					const {
						dataset: { value: thisVal },
					} = button;

					// Unselect all size buttons.
					sizeButtons.forEach((sizeButton) => {
						sizeButton.removeAttribute('data-selected');
					});
					// Set selected data attribute on button.
					button.setAttribute('data-selected', 'true');
					// Set size select value.
					sizeSelect.value = thisVal;
					// Trigger change event on size select.
					sizeSelect.dispatchEvent(
						new Event('change', {
							bubbles: true,
							cancelable: true,
						})
					);
				});
			});

			document.addEventListener(
				'woocommerce_variation_has_changed',
				() => {
					//console.log('woocommerce_variation_has_changed');

					const sizeSelectOptions =
						sizeSelect.querySelectorAll('option');

					// Hide all size buttons first.
					sizeButtons.forEach((button) => {
						button.setAttribute('data-disabled', 'true');
					});

					// Then loop through select options and display each corresponding size button.
					sizeSelectOptions.forEach((option) => {
						const optionVal = option.value;
						const sizeButton = document.querySelector(
							'button[data-value="' + optionVal + '"]'
						);
						if (sizeButton) {
							sizeButton.removeAttribute('data-disabled');
						}
					});
				}
			);
		}
	}

	/**
	 * Product archive filter accordion.
	 */
	function productArchiveFilterAccordion() {
		const queryParams = new URLSearchParams(window.location.search);
		const productFilterModalOpen = document.querySelector(
			'.product-archive_filters-modal-open'
		);
		const productFilterModalClose = document.querySelectorAll(
			'.product-archive_filters-modal-close'
		);
		const productFilterAccordion = document.querySelector(
			'.product-archive__filters-accordion'
		);
		const productFilterAccordionItems =
			productFilterAccordion?.querySelectorAll(
				'.product-archive__filters-accordion-item'
			);

		document.body.addEventListener('click', function (e) {
			handleAccordionToggle(e, queryParams);
		});

		if (productFilterModalOpen) {
			productFilterModalOpen.addEventListener('click', toggleModal);
		}

		if (productFilterModalClose) {
			productFilterModalClose.forEach((element) =>
				element.addEventListener('click', toggleModal)
			);
		}

		if (productFilterAccordionItems) {
			productFilterAccordionItems.forEach((accordionItem) => {
				const toggle = accordionItem.querySelector(
					'.product-archive__filters-accordion-toggle'
				);
				if (!toggle) return;
				// Open accordion on load if query param is set.
				const facetWPKey =
					accordionItem.getAttribute('data-facetwp-key');
				if (queryParams && queryParams.get(facetWPKey)) {
					toggle.classList.add('active');
				}
			});
		}
	}

	function handleAccordionToggle(e) {
		if (e.target.matches('.product-archive__filters-accordion-toggle')) {
			e.preventDefault();
			e.target.classList.toggle('active');
		}
	}

	function toggleModal(e) {
		e.preventDefault();
		document.body.classList.toggle('product-archive__filters-modal-active');
	}

	document.addEventListener('facetwp-refresh', function () {
		//console.log('facetwp-refresh event detected');
		if (typeof FWP !== 'undefined' && FWP) {
			if (FWP.soft_refresh === true) {
				FWP.enable_scroll = true;
			} else {
				FWP.enable_scroll = false;
			}
			if (FWP.loaded) {
				toggleResetButton();

				const topBarLeft = document.querySelector(
					'.product-archive__top-bar-left'
				);
				if (topBarLeft) {
					const loadingIcon = document.createElement('div');
					loadingIcon.className = 'loading-icon';
					topBarLeft.appendChild(loadingIcon);
				}

				const products = document.querySelectorAll(
					'.facetwp-template .products'
				);
				products.forEach((el) => {
					el.style.opacity = '0.25';
				});
			}
		}
	});

	document.addEventListener('facetwp-loaded', function () {
		//console.log('facetwp-loaded event detected');
		const products = document.querySelectorAll(
			'.facetwp-template .products'
		);
		products.forEach((el) => {
			el.style.opacity = '1';
		});

		toggleResetButton();
	});

	// Set opacity on products
	const products = document.querySelectorAll('.facetwp-template .products');
	products.forEach((el) => {
		el.style.opacity = '1';
	});

	init();
};

export default PropelWoocommerce;
